import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	saveButton: {
		id: 'portal-settings-request-groups.portal-group.create-toolbar.save-button',
		defaultMessage: 'Save',
		description: 'Label used in save button',
	},
	cancelButton: {
		id: 'portal-settings-request-groups.portal-group.create-toolbar.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Label used in cancel button',
	},
	gateMessage: {
		id: 'portal-settings-request-groups.portal-group.create-toolbar.gate-message',
		defaultMessage: 'Add a name and request form to save',
		description: 'Message shown on tooltip when user does not have enough information to save',
	},
	genericError: {
		id: 'portal-settings-request-groups.portal-group.create-toolbar.generic-error',
		defaultMessage: "We couldn't create this group. Refresh and try again.",
		description: 'Message shown when something went wrong saving',
	},
	duplicateNameError: {
		id: 'portal-settings-request-groups.portal-group.create-toolbar.duplicate-name-error',
		defaultMessage: 'This name is already in use, try another.',
		description:
			'Message shown when creating a group with a name that is already used by another group',
	},
	groupNameTooLongError: {
		id: 'portal-settings-request-groups.portal-group.create-toolbar.group-name-too-long-error',
		defaultMessage: "Group name can't be longer than 128 characters.",
		description: 'Message shown when creating a group with a name that is too long',
	},
	missingGroupNameError: {
		id: 'portal-settings-request-groups.portal-group.create-toolbar.missing-group-name-error',
		defaultMessage: "Group name can't be empty.",
		description: 'Message shown when creating a group with no name',
	},
	missingRequestFormError: {
		id: 'portal-settings-request-groups.portal-group.create-toolbar.missing-request-form-error',
		defaultMessage: 'One or more forms no longer exist. Refresh and try again.',
		description:
			'Message shown a group is being created with deleted or invalid request forms added',
	},
	invalidRequestFormError: {
		id: 'portal-settings-request-groups.portal-group.create-toolbar.invalid-request-form-error',
		defaultMessage: 'One or more forms are invalid. Refresh and try again.',
		description:
			'Message shown a group is being created with deleted or invalid request forms added',
	},
});
